import Button from 'antd/lib/button';
import * as React from 'react';
import InviteTeamModal from './InviteTeamModal';
import { PlusOutlined } from '@ant-design/icons';
import { OrgComponentProps } from '../../typescriptHelpers';

const InviteTeamContainer: React.FC<OrgComponentProps> = (props: OrgComponentProps) => {
    const [showInviteTeamModal, setShowInviteTeamModal] = React.useState(false);
    return (
        <>
            <Button onClick={() => setShowInviteTeamModal(true)} type="primary" icon={<PlusOutlined />}>
                Invite team
            </Button>
            <InviteTeamModal open={showInviteTeamModal} onCancel={() => setShowInviteTeamModal(false)} {...props} />
        </>
    );
};

export default InviteTeamContainer;
